<template>
  <div class="approval-container">
    <van-nav-bar title="供应商认定结果审批" left-arrow left-text="返回" @click-left="onClickLeft" :fixed="true" />
    <van-collapse class="approval-info" v-model="activeNames">
      <van-collapse-item name="baseInfo" border title-class="title-class">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">基本信息</span>
        </template>
        <base-info :head-info="headInfo" />
      </van-collapse-item>
      <van-collapse-item name="applyInfo" border title-class="title-class">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">申请明细</span>
        </template>
        <apply-info :apply-list="applyList" todo-name="SupplierResultApproval" />
      </van-collapse-item>
      <van-collapse-item name="conclusionResult" border title-class="title-class">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">综合评审结论</span>
        </template>
        <conclusion-result :conclusion-result-list="conclusionResultList" todo-name="SupplierResultApproval" />
      </van-collapse-item>
      <van-collapse-item name="conclusionInfo" border title-class="title-class">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">评审结论明细</span>
        </template>
        <conclusion-info :conclusion-info-list="conclusionInfoList" todo-name="SupplierResultApproval" />
      </van-collapse-item>
      <van-collapse-item name="attachment">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">附件信息</span>
        </template>
        <hi-attachment :attach-list="attachList"></hi-attachment>
      </van-collapse-item>
      <van-collapse-item name="approvalOpinions">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">审批意见</span>
        </template>
        <hi-flow-approval :page-context="thisPage" />
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import { supplierResultBase, supplierResultApply, supplierResultConclusion } from '@/api/supplierResult'
import Bridge from '@/components/dsbridge'
export default {
  name: 'SupplierResultApproval',
  components: {
    'base-info': () => import('./components/BaseInfo.vue'),
    'apply-info': () => import('./components/ApplyInfo.vue'),
    'conclusion-result': () => import('./components/ConclusionResult.vue'),
    'conclusion-info': () => import('./components/ConclusionInfo.vue')
  },
  data() {
    return {
      activeNames: ['baseInfo', 'approvalOpinions'],
      // identifyCode: this.$store.getters.businessKey,
      // resultApplyCode: this.$store.getters.businessKey,
      identifyCode: this.$route.query.businessKey,
      resultApplyCode: this.$route.query.businessKey,
      headInfo: {},
      attachList: [],
      applyList: [],
      conclusionResultList: [],
      conclusionInfoList: [],
      apiSuccess: undefined
    }
  },
  computed: {
    thisPage() {
      return this
    }
  },
  created() {
    this.initData()
  },
  methods: {
    initData() {
      this.headInfoFunc()
      this.applyFunc()
      this.conclusionResultFunc()
      this.conclusionInfoFunc()
    },
    async headInfoFunc() {
      const headInfoResp = await supplierResultBase(this.identifyCode)
      this.headInfo = headInfoResp.data
      this.attachList = this.headInfo.attachList
    },
    async applyFunc() {
      const applyResp = await supplierResultApply(this.resultApplyCode)
      this.applyList = applyResp.data
    },
    async conclusionResultFunc() {
      const conclusionResultResp = await supplierResultBase(this.identifyCode)
      this.conclusionResultList = conclusionResultResp.data
    },
    async conclusionInfoFunc() {
      const conclusionInfoResp = await supplierResultConclusion(this.resultApplyCode)
      this.conclusionInfoList = conclusionInfoResp.data
    },
    onClickLeft() {
      // this.$router.push('/todo')
      Bridge.callMethodSyn('app.jsLeavePage', '')
    }
  }
}
</script>
<style lang="scss" scoped>
.title-class {
  background-color: #eee;
}
</style>
